<template>
  <el-image-viewer
    v-if="visible && srcListFilter.length"
    :on-close="closeViewer"
    hide-on-click-modal="false"
    :url-list="srcListFilter"
    :initial-index="initialIndex"
    :z-index="9999"
  />
</template>

<script>
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
  export default {
    name: "bsp-image-preview",
    components: {
      ElImageViewer
    },
    props: {
      srcList: {
        type: Array | String,
        default() {
          return '';
        }
      },
      visible: {
        type: Boolean,
        default() {
          return false
        }
      },
      initialIndex: {
        type: Number,
        default() {
          return 0;
        }
      }
    },
    methods: {
      closeViewer() {
        this.$emit('close-preview');
      }
    },
    computed: {
      srcListFilter() {
        let srcList = [];
        if (typeof this.srcList == 'string') {
          srcList.push(this.srcList);
        }
        if (this.srcList instanceof Array) {
          srcList = this.srcList;
        }
        return srcList;
      }
    }
  }
</script>
